import { Message, Notification } from 'element-ui';
import * as types from '../mutation-types';
import { sendPayment, sendPaymentDue, confirmPayment, rejectPayment, getSearchedPayment, getSearchedPaymentTransaction, resetPayment } from '../../services/payments';

const state = {
  payments: [],
  paymentTransactions: [],
  paymentTransactionsDueSoon: [],
  poPayment: {},
  paymentsPagination: {},
  paymentTransactionsPagination: {},
  hasPaymentDue: false,
  isPaymentLoading: true,
  searchPaymentQuery: '',
  searchPaymentFilterQuery: '',
  searchPaymentFilterSelected: [],
  selectedDueDates: [],
  paymentsPaginationQuery: '',
  paymentTransactionsPaginationQuery: '',
  paymentsOrderBy: '&o=status,due',
  paymentTransactionsOrderBy: '&o=status,due',
};

const getters = {
  getPayments: state => state.payments,
  getsearchPaymentFilterSelected: state => state.searchPaymentFilterSelected,
  getSearchPaymentQuery: state => state.searchPaymentQuery,
  getPaymentTransactions: state => state.paymentTransactions,
  getPaymentTransactionsDueSoon: state => state.paymentTransactionsDueSoon,
  getPoPayment: state => state.poPayment,
  getHasPaymentDue: state => state.payments,
  getPaymentSearchQueryString: (state) => {
    let filtersQuery = '';
    // verify searchQuery
    if (state.searchPaymentQuery !== '') {
      filtersQuery += `${state.searchPaymentQuery}`;
    }
    // verify filters
    for (let i = 0; i < state.searchPaymentFilterSelected.length; i += 1) {
      if (filtersQuery !== '') {
        filtersQuery += '&';
      }
      filtersQuery += `status=${state.searchPaymentFilterSelected[i]}`;
    }
    // verify dueDate
    if (state.selectedDueDates !== null && state.selectedDueDates.length > 0) {
      if (filtersQuery !== '') {
        filtersQuery += '&';
      }
      filtersQuery += `due_0=${state.selectedDueDates[0]}`;
      filtersQuery += `&due_1=${state.selectedDueDates[1]}`;
    }
    if (filtersQuery !== '') {
      filtersQuery += '&';
    }
    filtersQuery += `${state.paymentTransactionsPaginationQuery}${state.paymentTransactionsOrderBy}`;
    filtersQuery = `?${filtersQuery}`;
    return filtersQuery;
  },
  getPaymentsPagination: state => state.paymentsPagination,
  getPaymentTransactionsPagination: state => state.paymentTransactionsPagination,
  getPaymentsLoading: state => state.isPaymentLoading,
  getSelectedDueDates: state => state.selectedDueDates,
};

const mutations = {
  [types.SET_PAYMENTS_LOADING](state, isLoading) {
    state.isPaymentLoading = isLoading;
  },
  [types.SET_PAYMENTS](state, poPayments) {
    state.payments = poPayments;
    state.isPaymentLoading = false;
  },
  [types.SET_PAYMENT_TRANSACTIONS](state, paymentTransactions) {
    state.paymentTransactions = paymentTransactions;
    state.isPaymentLoading = false;
  },
  [types.SET_PO_PAYMENT](state, poPayment) {
    state.poPayment = poPayment;
  },
  [types.SET_PAYMENT_DUE](state) {
    state.hasPaymentDue = true;
  },
  [types.SET_PAYMENTS_DUE_DATES](state, due) {
    state.selectedDueDates = due;
  },
  [types.ADD_PAYMENT_FILTER_QUERY](state, searchFilterPaymentQuery) {
    state.searchPaymentFilterSelected = searchFilterPaymentQuery.filtersSelected;
    state.searchPaymentFilterQuery = searchFilterPaymentQuery.query;
  },
  [types.ADD_PAYMENTS_SEARCHBAR_QUERY](state, searchPaymentQuery) {
    if (searchPaymentQuery === '') {
      state.searchPaymentQuery = searchPaymentQuery;
    } else {
      state.searchPaymentQuery = `q=${searchPaymentQuery}`;
    }
  },
  [types.SET_PAYMENT_ORDER_BY](state, paymentsOrderBy) {
    state.paymentsOrderBy = paymentsOrderBy;
  },
  [types.SET_PAYMENT_TRANSACTIONS_ORDER_BY](state, paymentTransactionsOrderBy) {
    state.paymentTransactionsOrderBy = paymentTransactionsOrderBy;
  },
  [types.SET_PAYMENT_TRANSACTIONS_DUE_SOON](state, paymentTransactionsDueSoon) {
    state.paymentTransactionsDueSoon = paymentTransactionsDueSoon;
  },
  [types.SET_PAYMENTS_PAGINATION](state, paymentsPagination) {
    state.paymentsPagination.perPage = parseInt(paymentsPagination.perPage);//eslint-disable-line
    state.paymentsPagination.page = paymentsPagination.page;
    state.paymentsPagination.total = paymentsPagination.total;
    state.paymentsPaginationQuery = `page=${paymentsPagination.page}&perPage=${paymentsPagination.perPage}`;
  },
  [types.SET_PAYMENT_TRANSACTIONS_PAGINATION](state, paymentTransactionsPagination) {
    state.paymentTransactionsPagination.perPage =
    parseInt(paymentTransactionsPagination.perPage);//eslint-disable-line
    state.paymentTransactionsPagination.page = paymentTransactionsPagination.page;
    state.paymentTransactionsPagination.total = paymentTransactionsPagination.total;
    state.paymentTransactionsPaginationQuery = `page=${paymentTransactionsPagination.page}&perPage=${paymentTransactionsPagination.perPage}`;
  },
};

const actions = {
  setPayment({ commit }, {
    poId, paymentId, payment, scope,
  }) {
    if (scope) {
      scope.isAddPaymentLoading = true;
    }
    sendPayment(poId, paymentId, payment).then(response => response.data).then((data) => {
      commit(types.SET_PO_ITEM, data);
      if (scope) {
        scope.isAddPaymentLoading = false;
        scope.payDialog = false;
      }
      Message.success('Success! Payment was added.');
    }).catch((error) => {
      if (error.response.data.message) {
        if (scope) {
          scope.isAddPaymentLoading = false;
          scope.payDialog = false;
        }
        Message.error(error.response.data.message);
      } else {
        if (scope) {
          scope.isAddPaymentLoading = false;
          scope.payDialog = false;
        }
        Message.error('Something went wrong! Try again.');
      }
    });
  },
  setPoPayment({ commit }, poPayment) {
    commit(types.SET_PO_PAYMENT, poPayment);
  },
  getSearchedPaymentData({ commit, getters }) {
    commit(types.SET_PAYMENTS_LOADING, true);
    getSearchedPayment(getters.getPaymentSearchQueryString)
      .then(response => response.data).then((data) => {
        commit(types.SET_PAYMENTS, data.results);
        commit(types.SET_PAYMENTS_PAGINATION, data.pagination);
        commit(types.SET_PAYMENTS_LOADING, false);
      }).catch((error) => {
        if (error.response.data.message) {
          Message.error(error.response.data.message);
        } else {
          Message.error('Something went wrong! Try again.');
        }
      });
  },
  getSearchedPaymentTransactionsData({ commit, getters }, changePage) {
    commit(types.SET_PAYMENTS_LOADING, true);
    let searchedUrl;
    let searchedQuery;
    if (!changePage) {
      const paginationObj = {};
      if (typeof getters.getPaymentTransactionsPagination.perPage === 'undefined') {
        paginationObj.perPage = '25';
      } else {
        paginationObj.perPage = getters.getPaymentTransactionsPagination.perPage;
      }
      paginationObj.page = 1;
      commit(types.SET_PAYMENT_TRANSACTIONS_PAGINATION, paginationObj);
    }
    getSearchedPaymentTransaction(getters.getPaymentSearchQueryString).then((response) => {
      searchedUrl = response.config.url;
      return response.data;
    }).then((data) => {
      searchedQuery = searchedUrl.substring(searchedUrl.lastIndexOf('?q=') + 1, searchedUrl.indexOf('&'));
      if (getters.getSearchPaymentQuery.indexOf('q=') === -1) {
        commit(types.SET_PAYMENT_TRANSACTIONS, data.results);
        commit(types.SET_PAYMENT_TRANSACTIONS_PAGINATION, data.pagination);
        commit(types.SET_PAYMENTS_LOADING, false);
      } else if (getters.getSearchPaymentQuery === searchedQuery) {
        commit(types.SET_PAYMENT_TRANSACTIONS, data.results);
        commit(types.SET_PAYMENT_TRANSACTIONS_PAGINATION, data.pagination);
        commit(types.SET_PAYMENTS_LOADING, false);
      }
    }).catch((error) => {
      if (error.response.data.message) {
        Message.error(error.response.data.message);
      } else {
        Message.error('Something went wrong! Try again.');
      }
    });
  },
  getPaymentTransactionsDueSoonData({ commit, getters }, dueQuery) {
    getSearchedPaymentTransaction(dueQuery).then(response => response.data).then((data) => {
      commit(types.SET_PAYMENT_TRANSACTIONS_DUE_SOON, data.results);
      const dueSoonArray = getters.getPaymentTransactionsDueSoon;
      let paymentDisplay = '';
      if (dueSoonArray.length > 1) {
        paymentDisplay = ' payments are going to be due in a week or less!';
      } else {
        paymentDisplay = ' payment is going to be due in a week or less!';
      }
      if (dueSoonArray.length > 0) {
        Notification.warning({
          title: 'Due Alert',
          message: dueSoonArray.length + paymentDisplay,
        });
      }
    }).catch((error) => {
      if (error.response.data.message) {
        Message.error(error.response.data.message);
      } else {
        Message.error('Something went wrong! Try again.');
      }
    });
  },
  setPaymentDue({ commit, dispatch }, { poId, paymentDue, scope }) {
    if (scope) {
      scope.isEditDueLoading = true;
      scope.isAddPaymentInfoLoading = true;
    }
    sendPaymentDue(poId, paymentDue).then(response => response.data).then((data) => {
      commit(types.SET_PO_ITEM, data);
      if (scope) {
        scope.isEditDueLoading = false;
        scope.editDueDialog = false;
        scope.isAddPaymentInfoLoading = false;
      }
      Message.success('Success! Due date updated');
      dispatch('getSearchedPaymentTransactionsData');
    }).catch((error) => {
      if (error.response.data.message) {
        Message.error(error.response.data.message);
        if (scope) {
          scope.editDueDialog = false;
          scope.isEditDueLoading = false;
          scope.isAddPaymentInfoLoading = false;
        }
      } else {
        Message.error('Something went wrong! Try again.');
        if (scope) {
          scope.editDueDialog = false;
          scope.isEditDueLoading = false;
          scope.isAddPaymentInfoLoading = false;
        }
      }
    });
  },
  sendPaymentConfirmation({ commit, dispatch }, {
    poId, paymentId, data, scope,
  }) {
    if (scope) {
      scope.isConfirmPaymentLoading = true;
    }
    confirmPayment(poId, paymentId, data).then(response => response.data).then((data) => {
      Message.success('Success! Payment was confirmed.');
      commit(types.SET_PO_ITEM, data);
      if (scope) {
        scope.confirmPaymentDialog = false;
        scope.isConfirmPaymentLoading = false;
      }
      dispatch('getSearchedPaymentTransactionsData');
    }).catch((error) => {
      if (error.response.data.message) {
        Message.error(error.response.data.message);
        if (scope) {
          scope.confirmPaymentDialog = false;
          scope.isConfirmPaymentLoading = false;
        }
      } else {
        Message.error('Something went wrong! Try again.');
        if (scope) {
          scope.confirmPaymentDialog = false;
          scope.isConfirmPaymentLoading = false;
        }
      }
    });
  },
  sendPaymentRejection({ commit, dispatch }, {
    poId, paymentId, data, scope,
  }) {
    if (scope) {
      scope.isRejectPaymentLoading = true;
    }
    rejectPayment(poId, paymentId, data).then(response => response.data).then((data) => {
      commit(types.SET_PO_ITEM, data);
      Message.success('Payment was rejected.');
      if (scope) {
        scope.isRejectPaymentLoading = false;
        scope.rejectPaymentDialog = false;
        scope.rejectForm.rejectPaymentObs = '';
      }
      dispatch('getSearchedPaymentTransactionsData');
    }).catch((error) => {
      if (error.response.data.message) {
        Message.error(error.response.data.message);
        if (scope) {
          scope.isRejectPaymentLoading = false;
          scope.rejectPaymentDialog = false;
        }
      } else {
        Message.error('Something went wrong! Try again.');
        if (scope) {
          scope.isRejectPaymentLoading = false;
          scope.rejectPaymentDialog = false;
        }
      }
    });
  },
  setFilterPayment({ commit }, q) {
    return commit(types.ADD_PAYMENT_FILTER_QUERY, q);
  },
  setPaymentSearchQuery({ commit }, q) {
    return commit(types.ADD_PAYMENTS_SEARCHBAR_QUERY, q);
  },
  setPaymentsSelectedDueDates({ commit }, dueDates) {
    commit(types.SET_PAYMENTS_DUE_DATES, dueDates);
  },
  updatePaymentTransactionsOrderBy({ commit }, orderByQuery) {
    return commit(types.SET_PAYMENT_TRANSACTIONS_ORDER_BY, orderByQuery);
  },
  updatePaymentTransactionsPagination({ commit }, paginationQuery) {
    return commit(types.SET_PAYMENT_TRANSACTIONS_PAGINATION, paginationQuery);
  },
  sendResetConfirmation({ commit }, {
    poId, paymentId, data, scope,
  }) {
    if (scope) {
      scope.isUndoLoading = true;
    }
    resetPayment(poId, paymentId, data).then(response => response.data).then((data) => {
      commit(types.SET_PO_ITEM, data);
      if (scope) {
        scope.isUndoLoading = false;
      }
      Message.success('Undo success!');
    }).catch((error) => {
      if (error.response.data.message) {
        if (scope) {
          scope.isUndoLoading = false;
        }
        Message.error(error.response.data.message);
      } else {
        if (scope) {
          scope.isUndoLoading = false;
        }
        Message.error('Something went wrong! Try again.');
      }
    });
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/payments.js